export const BASE_URL =
  process.env.REACT_APP_BASE_URL ||
  window?.BASE_URL ||
  "https://ldssetupdev.ilsp.gr/registry";
export const KEYCLOAK_CONFNIG =
  process.env.REACT_APP_KEYCLOAK_CONFNIG || window?.KEYCLOAK_CONFNIG
    ? JSON.parse(JSON.stringify(window.KEYCLOAK_CONFNIG))
    : {};
export const PARTICIPANT_FORM_SUBMITION =
  BASE_URL + "/api/registry/participants/"; //POST and GET
export const PARTICIPANT_FORM_SCHEMA =
  BASE_URL + "/api/registry/participant/schema/"; //GET
  export const PARTICIPANT_FORM_CONNECTOR_SCHEMA =
  BASE_URL + "/api/registry/connector/schema/"; //GET
export const PARTICIPANT_APPROVAL_API =
  BASE_URL + "/api/registry/participant-application/"; //PUT
// export const PARTICIPANT_REJECT_PRE_APPROVE_API =
//  BASE_URL + "api/registry/participant-pre-approval/"; //PUT
export const PARTICIPANT_REQUEST_STATUS_CHANGE_API =
  BASE_URL + "/api/registry/request_status_change/"; //PUT
export const PARTICIPANT_EVALUATE_STATUS_CHANGE_API =
  BASE_URL + "/api/registry/evaluate_status_change/"; //PUT
export const PARTICIPANT_SUSPEND_API =
  BASE_URL + "/api/registry/suspend/"; //PUT
  export const PARTICIPANT_UNSUSPEND_API =
  BASE_URL + "/api/registry/unsuspend/"; //PUT
  export const PARTICIPANT_REOPEN_API =
  BASE_URL + "/api/registry/reopen/";  // api/registry/reopen/ allowed for admin for withdrawn/rejected status
export const PARTICIPANT_WITHDRAW_API =
  BASE_URL + "/api/registry/withdraw/"; //PUT
export const PARTICIPANT_DISPLAY = (id) =>
  `${BASE_URL}/api/registry/participants/${id}/`;
export const PARTICIPANT_CONNECTOR = (id) =>
  `${BASE_URL}/api/registry/connectors/${id}/`;
  export const PARTICIPANT_CONNECTORS =
  BASE_URL + "/api/registry/connectors/"; // GET/POST
  export const PARTICIPANT_EXPORT_API =
  BASE_URL + "/api/registry/export/";


  /*api/registry/participant/schema/en/' 	Participant Schema	public   GET
api/registry/connector/schema/en/' 	Connector Schema	public GET
api/registry/participants/		List/Create Participant(s)	admin / participant (is owner) GET/POST
api/registry/participants/[id]/		Get/Update/Delete Participant		admin / participant (is owner) GET/PUT/DELETE
api/registry/connectors/		List/Create Connector(s)		admin / participant (is owner of connector's participant object) GET/POST
api/registry/connectors/[id]		Get/Update/Delete Connector		admin / participant (is owner of connector's participant object) GET/PUT/DELETE
*/